import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ListGroup, OverlayTrigger,Tooltip } from 'react-bootstrap';
import UserPhoto from '../../../../../components/user-photo/user-photo';
import TasksDynamicFieldsContent from '../../../../../components/DynamicField/Tasks/ContentViewer/Content';
import { renderTranscript } from '../../../../../util/string-helpers';
import TaskAuditReassignMembers from '../ReassignComment/TaskAuditReassignMembers';
import "./FileAttachmentListModalNew.scss";
import "../shared-modal-header.scss";
const FileAttachmentListModalNew = ({
    filesList,
    setFilesList,
    currComment,
    docPathList,
    setShowDocFileViewer,
    setOneDoc,
    setCommentViewer,
    setCommentAttachment,
    projectTypeID,
    workItemType,
    onDownloadingFiles
}) => {
    return (
        <div onClick={(e) => e.stopPropagation()}>
            <Modal
                scrollable={true}
                backdrop={true}
                backdropClassName="mult-backdrop"
                show={filesList}
                onHide={() => setFilesList(false)}
                className="tasks-actions-popup view-multiple-files-popup"
            >
                <Modal.Header className="header-popup commentHeader" closeButton>
                    <Modal.Title className="actions-title task-comments-title">
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{currComment.Action === "Reassigned" ? "Re-Assigned" : currComment.Action}
                            </Tooltip>}
                        >
                            <div className="taskAuditStatusContainer ">
                                {currComment.Action === "Reassigned" ? "Re-Assigned" : currComment.Action}
                            </div>
                        </OverlayTrigger>
                        Audit Trail Log
                    </Modal.Title>
                </Modal.Header>
                <div className="select-member-divider-line"></div>
                <Modal.Body className="multiple-files-row-container">
                    {currComment?.Transcript && currComment?.Transcript !== "" ?
                        <Modal.Title className="actions-header">
                            <div className="comment-container-popup">
                                <div className="comment-body">
                                    {renderTranscript(currComment.Transcript)}
                                </div>
                            </div>
                        </Modal.Title>
                        :
                        (currComment.ActionId === 5 && currComment.ReassignTaskMembers != null) ?
                            <Modal.Title className="actions-header"><TaskAuditReassignMembers
                                comment={currComment}
                                projectMembers={currComment.ReassignTaskMembers?.ReassignUsers}
                                userName={currComment.CreatedBy?.Name}
                                userEmail={currComment.CreatedBy?.Email}
                                actionType={currComment.Action}
                            /></Modal.Title>
                            :
                            <Modal.Title className="actions-header">
                                Logged by
                                <div className="comment-container-popup">
                                    <UserPhoto name={currComment.ExternalEmail ?? currComment.CreatedBy?.Name} comments={true} photo={null} />
                                    <div className="comment-body">
                                        <div className="full-comment-header text-break">
                                            {currComment?.ExternalEmail ?? currComment.CreatedBy?.Name}
                                        </div>
                                        <div className={`text-break full-comment ${currComment?.Note?.substring(0, 1) === "<" ? "comment-grey-text" : ""}`}>
                                            {currComment?.Note ?? ""}
                                        </div>
                                    </div>
                                    <div className={"comment-padding"}></div>
                                </div>
                            </Modal.Title>
                    }
                    {currComment &&
                        <TasksDynamicFieldsContent
                            taskTypeId={workItemType}
                            objectId={currComment.Id}
                        />
                    }
                    {
                        currComment && currComment.Files?.length !== 0 &&
                        <React.Fragment>
                            <Modal.Title className="actions-header-files">Files</Modal.Title>
                            <div className="comment-files-row-container">
                                {currComment?.Files?.map((doc, idx) => {
                                    doc.docPath = docPathList[idx];
                                    return (
                                        <div className="comment-files-row" key={doc.FileId}>
                                            <ListGroup.Item className="multiple-files-row comment-files d-flex">
                                                <div className="left-aligned comment-file-name">
                                                    {doc.FileName}
                                                </div>
                                                <div className="btn-icon-container multiple-files-icon">
                                                    <button
                                                        className="btn-icon view-file-icon"
                                                        onClick={() => {
                                                            setShowDocFileViewer(true);
                                                            setOneDoc(doc);
                                                            setCommentViewer(true);
                                                            setCommentAttachment(1);
                                                        }}
                                                    >
                                                    </button>
                                                    <button
                                                        className="btn-icon download-file-icon"
                                                        onClick={() => onDownloadingFiles([doc], currComment)}
                                                    >
                                                    </button>
                                                </div>
                                            </ListGroup.Item>
                                            <div className="divider-line divider-files"></div>
                                        </div>
                                    )
                                })}
                            </div>
                        </React.Fragment>
                    }
                </Modal.Body>
            </Modal>
        </div>
    );
};

FileAttachmentListModalNew.propTypes = {
    filesList: PropTypes.bool.isRequired,
    setFilesList: PropTypes.func.isRequired,
    currComment: PropTypes.object.isRequired,
    docPathList: PropTypes.array.isRequired,
    setShowDocFileViewer: PropTypes.func.isRequired,
    setOneDoc: PropTypes.func.isRequired,
    setCommentViewer: PropTypes.func.isRequired,
    setCommentAttachment: PropTypes.func.isRequired,
    projectTypeID: PropTypes.number,
    workItemType: PropTypes.number.isRequired,
    onDownloadingFiles: PropTypes.func.isRequired
};

export default FileAttachmentListModalNew;
